var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTelevisionSimple = function SvgIconTelevisionSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.207 1.543a1 1 0 0 0-1.414 1.414L9.586 5.75H3.75A1.75 1.75 0 0 0 2 7.5v11.25c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 18.75V7.5a1.75 1.75 0 0 0-1.75-1.75h-5.836l2.793-2.793a1 1 0 0 0-1.414-1.414L12 5.336zM4 18.5V7.75h16V18.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTelevisionSimple;